/**
 * Resolve a photo URL so it works both when stored as an absolute URL
 * (http/https) and when stored as a relative path (e.g. "/api/files/...").
 * Relative paths are prefixed with REACT_APP_BACKEND_URL so images load
 * regardless of the domain the SPA is currently served from.
 */
export function resolvePhotoUrl(url) {
  if (!url || typeof url !== "string") return url;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("data:") || url.startsWith("blob:")) return url;
  const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  return `${base}${url.startsWith("/") ? "" : "/"}${url}`;
}
